import {
  Box,
  Button,
  Center,
  Divider,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { XIcon } from '@/imports/ui/chakra/feather'; 

interface RequestFailedModalProps {
  isOpen: boolean;
  errorMessage?: string;
  onClose: () => void;
}

export const RequestFailedModal: React.FC<RequestFailedModalProps> = ({
  isOpen,
  errorMessage = 'An error occurred while submitting your request.',
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="600px" borderRadius="xl">
        <ModalCloseButton mt="2" mr="2" />
        <ModalHeader pt="6" pb="2">
          <Text fontSize="xl" fontWeight="semibold">
            Request failed
          </Text>
          <Text fontSize="sm" color="gray.600" fontWeight="normal" mt="1">
            There was a problem submitting your request.
          </Text>
        </ModalHeader>
        <Divider />
        <ModalBody pb="6">
          <Stack spacing="4">

            <Box
            mt="3"
              bg="red.50"
              border="1px solid"
              borderColor="red.200"
              borderRadius="md"
              p="6"
            >
              <Stack spacing="4" align="center">
                <Box
                  w="42px"
                  h="42px"
                  borderRadius="full"
                  bg="red.500"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <XIcon w="20px" h="20px" color="white" />
                </Box>
                <VStack spacing="1" align="center" textAlign="center">
                  <Text fontSize="md" fontWeight="bold" color="gray.900">
                    Request submission failed
                  </Text>
                  <Text fontSize="sm" color="gray.800">
                    {errorMessage}
                  </Text>
                </VStack>
              </Stack>
            </Box>

            <HStack w="full" justify="flex-end" pt="2" spacing="3">
              <Button onClick={onClose} colorScheme="blue">
                Close
              </Button>
            </HStack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
